import { PartialBrief } from '../../../Types/Brief'
import getFormSequence from '../Sequences/GetFormSequence'

interface CompletionStats {
  totalSteps: number
  completedSteps: number
}

const getCompletionStats = (brief: PartialBrief, currentStep?: string): CompletionStats => {
  const { sequence } = getFormSequence(brief)
  const totalStepsCount = sequence.length
  const currentIndex = sequence.findIndex(({ path }) => path === currentStep)

  // Optional steps (e.g. venue styles) always count as complete, so without this the bar would
  // already include them from the start and then stall while the user passes through them.
  // Only count steps the user has reached.
  const completedSteps = sequence.filter(
    ({ isStepComplete }, index) =>
      (currentIndex === -1 || index < currentIndex) && isStepComplete(brief)
  )

  return {
    totalSteps: totalStepsCount,
    completedSteps: completedSteps.length,
  }
}

export default getCompletionStats
